import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Footer from "./FooterNew/index";
import Banner from "../components/Banner/Banner";
import WorkSection from "./Work Section/workSection";
import AdvantageSection from "./AdvantageSection/advantage";
import MLOLicense from "./mloLicenseSection/mloLicense";
import ReadyToLeap from "./ReadyToLeap/readyToLeap";
import MinutesSection from "./Minutes Section/minutesSection";
import jsonData from "./ai-branding.json";

export default function Home() {
  const [dpaData, setDPAData] = useState(null); // Initialize with null
  const [loanOfficer, setLoanOfficer] = useState(null); // Initialize with null
  const [links, setLinks] = useState(null); // Initialize with null

  const sectionRef = useRef(null);

  useEffect(() => {
    const fetchdpaJSON = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_JOIN_OUR_TEAM_JSON);
        setDPAData(response.data);
      } catch (error) {
        // console.log("Error fetching DPA JSON:", error);
      }
    };

    fetchdpaJSON();
  }, []);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now();
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks();
    }
  }, [links]);

  const scrollToSection = () => {
    const navbarHeight = document.getElementById("navbar").clientHeight;
    const sectionTop = sectionRef.current.offsetTop - navbarHeight;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });
  };

  if (dpaData) {
    const bannerData = dpaData.banner;
    const assistanceData = dpaData.assistance;
    const dpahelpData = dpaData.dpahelp;
    const workData = dpaData.work;
    const faqData = dpaData.faq;
    const minutesData = dpaData.disclaimer;

    return (
      <>
        {bannerData && (
          <Banner bannerData={bannerData} fetchpriority="high" />
        )}
        {assistanceData && (
          <AdvantageSection
            assistanceData={assistanceData}
            fetchpriority="low"
            sectionRef={sectionRef}
            scrollToSection={scrollToSection}
          />
        )}
        {dpahelpData && (
          <MLOLicense dpahelpData={dpahelpData} fetchpriority="low" />
        )}
        {workData && (
          <WorkSection
            workData={workData}
            fetchpriority="low"
            handleOnClick={scrollToSection}
          />
        )}
        {faqData && (
          <ReadyToLeap faqData={faqData} fetchpriority="low" />
        )}
        {minutesData && (
          <MinutesSection
            minutesData={minutesData}
            fetchpriority="low"
            handleOnClick={scrollToSection}
          />
        )}
        <Footer fetchpriority="low" links={links} />
      </>
    );
  } else {
    return null;
  }
}
